export function getUniqueElements<TElement>(
    array: TElement[],
    keySelector: (element: TElement) => any = el => el
): TElement[] {

    return array
        .map(el => ({
            key: keySelector(el),
            value: el
        }))
        .reduce(
            (result, pair) => {
                if (!result.some(p => p.key === pair.key)) {
                    result.push(pair);
                }
                return result;
            },
            new Array<{key: any, value: TElement}>()
        )
        .map(pair => pair.value);
}
